import MUIDataTable from "mui-datatables";
import React, { useState, useEffect } from "react";

import SingleSelectSortField from "./SingleSelectSortField";

const RollforwardTable = ({
    reportData,
    sortField,
    setSortField,
    sortDirectionField,
    setSortDirectionField,
    sortOptions,
    sortDirections,
}) => {
    const columns = [
        {
            name: "customer",
            label: "Customer",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",

                        paddingLeft: "15px",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "effective_date",
            label: "Effective Date",
            options: {
                setCellProps: () => ({
                    style: {},
                }),
                setCellHeaderProps: () => ({
                    style: {
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "product",
            label: "Product",
            options: {
                setCellProps: () => ({
                    style: {},
                }),
                setCellHeaderProps: () => ({
                    style: {
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "adjustment_type",
            label: "CARR Type",
            options: {
                setCellProps: () => ({
                    style: {},
                }),
                setCellHeaderProps: () => ({
                    style: {
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "churn_reason",
            label: "Churn Reason",
            options: {
                setCellProps: () => ({
                    style: {},
                }),
                setCellHeaderProps: () => ({
                    style: {
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "comments",
            label: "Comments",
            options: {
                setCellProps: () => ({
                    style: {},
                }),
                setCellHeaderProps: () => ({
                    style: {
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "carr",
            label: "CARR Amount",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "120px",

                        textAlign: "right",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        textAlign: "right",
                        fontWeight: "bold",
                    },
                }),
            },
        },
    ];

    const options = {
        responsive: "standard",
        selectableRows: "none",
        filter: false,
        sort: false,
        viewColumns: false,
        print: false,
        download: false,
        search: false,
        columnOrder: null,
        fixedHeader: true,
        pagination: true,
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 75, 100],
    };

    return (
        <MUIDataTable
            data={reportData}
            columns={columns}
            options={options}
            style={{ marginTop: "80px" }}
            className="ngShadow"
        />
    );
};

export default RollforwardTable;
